module.exports = __webpack_public_path__ + "img/annotation-heart.6c6b9aa9.svg";